if (!customElements.get('together-bought-product')) {
  customElements.define(
    'together-bought-product',
    class TogetherBoughtProduct extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loading === 'true') return;

        this.dataset.loading = 'true';
        this.load();
      }

      async load() {
        const section = this.closest('[data-together-bought-section]');

        try {
          const searchUrl = new URL(this.dataset.searchUrl, window.location.origin);
          searchUrl.searchParams.set('view', 'together-bought');
          searchUrl.searchParams.set('type', 'product');
          searchUrl.searchParams.set('q', `tag:${this.dataset.tag}`);

          const response = await fetch(searchUrl.toString());
          if (!response.ok) throw new Error(`Together-bought search failed: ${response.status}`);

          const responseDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
          const result = responseDocument.querySelector('[data-together-bought-result]');
          const productId = result?.dataset.productId;
          const excludedIds = section?.dataset.excludedProductIds || '';

          if (!result || excludedIds.includes(`,${productId},`)) {
            this.remove();
            this.finalize(section);
            return;
          }

          const template = result.querySelector(`[data-together-bought-${this.dataset.context}]`);
          if (!template) throw new Error(`Together-bought template is missing for ${this.dataset.context}`);

          const content = template.content.cloneNode(true);
          const productCard = content.firstElementChild;
          if (productCard) {
            productCard.dataset.togetherBoughtProduct = productId;
          }

          this.replaceWith(content);
          this.finalize(section);
        }
        catch (error) {
          console.error(error);
          this.remove();
          this.finalize(section);
        }
      }

      finalize(section) {
        if (!section || section.querySelector('together-bought-product')) return;

        const seenProductIds = new Set();
        section.querySelectorAll('[data-together-bought-product]').forEach((productCard) => {
          const productId = productCard.dataset.togetherBoughtProduct;
          if (seenProductIds.has(productId)) {
            productCard.remove();
          }
          else {
            seenProductIds.add(productId);
          }
        });

        if (seenProductIds.size > 0) {
          section.hidden = false;
        }
        else {
          section.remove();
        }
      }
    }
  );
}
